import { render, staticRenderFns } from "./No05.vue?vue&type=template&id=8824c03a&scoped=true"
import script from "./No05.vue?vue&type=script&lang=js"
export * from "./No05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8824c03a",
  null
  
)

export default component.exports